module.exports = __webpack_public_path__ + "static/img/dw.ab06120.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/dw.jpg
// module id = 7DW2
// module chunks = 7